import { createContext, useContext, useState, useCallback, useEffect } from "react";

const SportContext = createContext(null);

export const useSport = () => {
  const ctx = useContext(SportContext);
  if (!ctx) throw new Error("useSport must be used within SportProvider");
  return ctx;
};

// FIFA window: football is the default sport. Persisted to localStorage.
// One-time migration: force every existing user (including those who previously
// chose "Stay in Cricket") onto football now that IPL is over. They can still
// toggle back via SportNavigator; the flag prevents re-applying on every launch.
const resolveInitialSport = () => {
  if (localStorage.getItem("football_default_applied") !== "1") {
    localStorage.setItem("active_sport", "football");
    localStorage.setItem("football_default_applied", "1");
    return "football";
  }
  return localStorage.getItem("active_sport") || "football";
};

export const SportProvider = ({ children }) => {
  const [sport, setSportState] = useState(resolveInitialSport);
  const setSport = useCallback((s) => {
    localStorage.setItem("active_sport", s);
    setSportState(s);
  }, []);
  // Deep-link support: ?sport=cricket / ?sport=football (used by email CTAs) sets
  // and persists the active sport on load so links land on the right experience.
  useEffect(() => {
    const s = new URLSearchParams(window.location.search).get("sport");
    if (s === "cricket" || s === "football") {
      localStorage.setItem("active_sport", s);
      localStorage.setItem("football_default_applied", "1");
      setSportState(s);
    }
  }, []);
  return <SportContext.Provider value={{ sport, setSport }}>{children}</SportContext.Provider>;
};
